import { connect } from 'react-redux';
import ForgotPassword from '../../../components/ForgotPage/ForgotPassword';

export default connect()(ForgotPassword);
